<!-- components/common/Card.vue -->
<template>
  <div class="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
    <slot />
  </div>
</template>
